"use strict";Object.defineProperty(exports, "__esModule", {value: true});var ENTITY_TYPES; (function (ENTITY_TYPES) {
  const PATIENT = 'patient_entity'; ENTITY_TYPES["PATIENT"] = PATIENT;
  const USER = 'user_entity'; ENTITY_TYPES["USER"] = USER;
  const TEAM = 'team_entity'; ENTITY_TYPES["TEAM"] = TEAM;
  const CONTACT = 'contact_entity'; ENTITY_TYPES["CONTACT"] = CONTACT;
  const ORG = 'org_entity'; ENTITY_TYPES["ORG"] = ORG;
  const RELATIONSHIP = 'relationship_entity'; ENTITY_TYPES["RELATIONSHIP"] = RELATIONSHIP;
})(ENTITY_TYPES || (exports.ENTITY_TYPES = ENTITY_TYPES = {}));
